import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';
import {
  DropdownOption,
} from '@shared/components/form-fields/input-select/input-select';
import { Button } from '@shared/components/form-fields/button/button';
import { FormControl } from '@angular/forms';
import { DemoRequestInquiry, Inquiry } from '@app/core/models/inquiries.model';
import { InquiryType } from '@app/core/enums/common.enums';
import { CommonService } from '@app/core/services/common.service';
import { AlertService } from '@app/core/services/alert.service';

@Component({
  selector: 'app-guest-footer',
  imports: [CommonModule, RouterLink, ReactiveFormsModule, Button],
  templateUrl: './guest-footer.html',
  styleUrl: './guest-footer.scss',
})
export class GuestFooter implements OnInit {
  isLoading: boolean = false;
  APP_ROUTES = APP_ROUTES;

  newsletterForm: FormGroup;

  selectedLanguage: string = 'English';
  languageDropdownOpen: boolean = false;

  languages: DropdownOption[] = [
    { value: 'en', label: 'English' },
    // { value: 'es', label: 'Spanish' },
    // { value: 'fr', label: 'French' },
    // { value: 'de', label: 'German' },
    // { value: 'it', label: 'Italian' },
  ];

  // Sample countries - you can replace with actual country list from master service
  countries: DropdownOption[] = [
    { value: 'us', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'in', label: 'India' },
    { value: 'ca', label: 'Canada' },
    { value: 'au', label: 'Australia' },
    { value: 'de', label: 'Germany' },
    { value: 'fr', label: 'France' },
  ];

  socialLinks = [
    { icon: 'bi bi-facebook', url: 'https://www.facebook.com/quapttech' },
    { icon: 'bi bi-linkedin', url: 'https://www.linkedin.com/company/quapt-technologies-private-limited/posts/?feedView=all' },
    // { icon: 'bi bi-youtube', url: 'https://www.youtube.com' },
    { icon: 'bi bi-twitter-x', url: 'https://x.com/quapttech' },
    { icon: 'bi bi-instagram', url: 'https://www.instagram.com/quapt_tech' },
  ];

  companyLinks = [
    { label: 'Our Story', route: [APP_ROUTES.GUEST.COMPANY.ROOT, APP_ROUTES.GUEST.COMPANY.ABOUT], openInNewTab: false },
    {
      label: 'Contact Us',
      route: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.CONTACT_US],
      openInNewTab: false,
    },
    {
      label: 'Terms & Condition',
      route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.TERMS_OF_SERVICE],
      openInNewTab: true,
    },
    {
      label: 'Privacy Policy',
      route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.PRIVACY_POLICY],
      openInNewTab: true,
    },
  ];

  productLinks = [
    { label: 'Pricing', route: [APP_ROUTES.GUEST.PRICING] },
    { label: 'Enterprise', route: `/${APP_ROUTES.GUEST.ENTERPRISE}` },
    {
      label: 'Use Cases',
      route: [
        APP_ROUTES.GUEST.PRODUCT,
        APP_ROUTES.GUEST.USE_CASES.ROOT,
        APP_ROUTES.GUEST.USE_CASES.ALL,
      ],
    },
    { label: 'FAQ', route: [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.FAQ] },
  ];

  resourcesLinks = [
    {
      label: 'Features',
      route:[
        APP_ROUTES.GUEST.PRODUCT,
        APP_ROUTES.GUEST.PLATFORM.ROOT,
        APP_ROUTES.GUEST.PLATFORM.FEATURES
      ],
    }, 
    // { label: 'Blogs', route: 
    //   '#'
    //   // [APP_ROUTES.GUEST.COMPANY.ROOT, APP_ROUTES.GUEST.COMPANY.BLOG]
    //  },
    // {
    //   label: 'Events',
    //   route: '#'
    //   // [APP_ROUTES.GUEST.RESOURCES.ROOT, APP_ROUTES.GUEST.RESOURCES.EVENTS]
    // },
    // {
    //   label: 'Customers',
    //   route: '#'
    //   // [APP_ROUTES.GUEST.RESOURCES.ROOT, APP_ROUTES.GUEST.RESOURCES.CUSTOMERS]
    // },
    // {
    //   label: 'Help Support',
    //   route: '#'
    //   // [APP_ROUTES.GUEST.SUPPORT.ROOT, APP_ROUTES.GUEST.SUPPORT.HELP_CENTER]
    // },
  ];

  legalLinks = [
    {
      label: 'Privacy Notes',
      route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.PRIVACY_POLICY],
      openInNewTab: true,
    },
    {
      label: 'Terms of Use',
      route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.TERMS_OF_SERVICE],
      openInNewTab: true,
    },
    { label: 'Cookies Notice',  route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.PRIVACY_POLICY], openInNewTab: true },
    { label: 'Legal',   route: [APP_ROUTES.GUEST.LEGAL.ROOT, APP_ROUTES.GUEST.LEGAL.TERMS_OF_SERVICE], openInNewTab: true },
  ];

  constructor(private commonService: CommonService,
    private router: Router,
    private alertService: AlertService) {
   this.newsletterForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phoneNumber: new FormControl(''),
    organizationName: new FormControl(''),
  });
  }

  ngOnInit(): void {}

  toggleLanguageDropdown(): void {
    this.languageDropdownOpen = !this.languageDropdownOpen;
  }

  selectLanguage(language: DropdownOption): void {
    this.selectedLanguage = language.label;
    this.languageDropdownOpen = false;
  }

  onSubscribe(): void {
    console.log("onsubscrbe clicked..");
    // if (this.newsletterForm.valid) {
    //   console.log('Newsletter subscription:', this.newsletterForm.value);
    //   // Implement newsletter subscription logic here
    //   this.newsletterForm.reset();
    // } else {
    //   this.newsletterForm.markAllAsTouched();
    // }
  
      if (this.newsletterForm.valid) {
        this.isLoading = true;
        const formValue = this.newsletterForm.value;
  
        // Combine name and lastName
        const fullName = formValue.lastName
          ? `${formValue.name} ${formValue.lastName}`.trim()
          : formValue.name || '';
  
        const newLetter: Inquiry = {
          name: fullName,
          email: formValue.email || '',
          organizationName: formValue.organizationName || '',
          phoneNumber: formValue.phoneNumber || '+919999999999',
          message: formValue.message || '',
          inquiryType: InquiryType.demo,
          teamSize: formValue.teamSize || '',
        };
  
        this.commonService.inquiriesLead(newLetter as DemoRequestInquiry).subscribe({
          next: (result) => {
            if (result.success) {
              console.log('Newletter Request Submitted:', newLetter);
              this.isLoading = false;
              this.newsletterForm.reset();
              this.alertService.showSuccessPopup(
                'Thanks for Subscribing',
                'You will be the first to receive on any new updates on our platform.',
                {
                  text: 'Continue',
                  action: () => {
                    this.alertService.clearAllPopupAlerts();
                  },
                },
                {
                  text: 'Close',
                  action: () => {
                    console.log('Cancel clicked');
                    this.alertService.clearAllPopupAlerts();
                  },
                }
              );
            } else {
              console.log('Demo Request Failed:', newLetter);
              this.isLoading = false;
            }
          },
          error: (err) => {
            console.log('Demo Request Failed:', err);
            this.alertService.showErrorPopup(
              'Oh, No',
              err.error.message,
              {
                text: 'Try Again',
                action: () => {
                  console.log('Try Again clicked');
                  this.alertService.clearAllPopupAlerts();
                },
              },
              {
                text: 'Close',
                action: () => {
                  console.log('Cancel clicked');
                  this.alertService.clearAllPopupAlerts();
                },
              }
            );
            this.isLoading = false;
          },
          complete: () => {
            this.isLoading = false;
          },
        });
      } else {
        this.newsletterForm.markAllAsTouched();
      }  

  }

  get emailControl(): FormControl {
    return this.newsletterForm.get('email') as FormControl;
  }

  get countryControl(): FormControl {
    return this.newsletterForm.get('country') as FormControl;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.guest-footer__language-wrapper')) {
      this.languageDropdownOpen = false;
    }
  }
}
